module.exports = __webpack_public_path__ + "img/step1.203267a5.png";